<app-banner [heading]="'OUR INFRA - AUDITORIUM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/auditorium/auditorium1.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-8 col-md-6">
            <div class="about-content">
              <h6 class=""> Auditorium</h6>
              
              <p>Our school promotes new avenues for the all-round development of the students. 
		  An important and critical feature of our school’s facilities is the auditorium. 
		  This grand hall has been the centre stage for a number of our students who have proved 
		  their mettle in dramatics, debates, musicals and other talent shows.The auditorium has
		  been the battle-field of several inter-school competitions and has seen hundreds of 
		  students showcase their finest talents.
			  </p>
              
            </div>
          </div>
		  
		</div>
      </div>
	</section><!-- End About Section -->
	
  </main>